<template>
  <div class="contatti">
    <common-hero
      :background="pageApiData.cover"
      :scroll="true"
      :hasClass="'--vh100'"
      :tag="'div'"
    >
    </common-hero>
    <section class="padding-paragrafo contatti-container">
      <div
        v-animate-on-intersection
        class="default-container">
        <h1>{{ pageApiData.title }}</h1>
        <p v-html="$t('testoFooter')" />
        <p v-html="$t('testoFooter2nd')" style="margin-bottom: 90px" />
        <LinkCta
          :to="{ name: `${lang}-richiesta-contatti`, params: { lang } }"
          :label="$t('richiediInfo')"
        />
      </div>
    </section>
  </div>
</template>

<script>
import lang from '@/views/mixins/lang'
import dataLoad from '@/views/mixins/dataLoad'
import CommonHero from '@/components/CommonHero'
import LinkCta from '@/components/LinkCta'

export default {
  mixins: [ lang, dataLoad ],
  components: {
    CommonHero,
    LinkCta
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .contatti-container{
    background-color: #FFF;
    h1 {
      text-transform: uppercase;
      @include section-title(#343434);
    }
    p {
      font-size: 1rem;
      line-height: 1.6;
      font-family: 'IBM Plex Mono', sans-serif;
      font-weight: 400;
      color: #343434;
      width: 90%;
      margin: 2rem 0;
      @media #{$medium_mq} {
        font-size: 1.1rem;
      }
      @media #{$large_mq} {
        font-size: 1.2rem;
        width: 80%;
        margin: 3rem 0;
      }
      @media #{$xlarge_mq} {
        font-size: 1.35rem;
        width: 70%;
      }
      @media #{$xxlarge_mq} {
        font-size: 1.5rem;
      }
    }
    p a{
      color: #343434;
      text-decoration: none;
    }
  }

</style>
